import { BaseHandler } from "./base.handler";
import type { WebSocketResponse } from "../../../types/types";
import { WebSocketService } from "../websocket.service";

export class HeartbeatHandler extends BaseHandler {
  ping(): void {
    this.logger.log("Sending ping");
    WebSocketService.getInstance().send("ping", {});
  }

  canHandle(messageType: string): boolean {
    return messageType === "ping" || messageType === "pong";
  }

  async handle(message: WebSocketResponse): Promise<void> {
    if (!this.validateMessage(message)) {
      this.logger.error("Invalid message format", message);
      return;
    }

    if (message.result === "ok") {
      this.logger.log("Heartbeat acknowledged");
    }
  }
}

// Singleton export
export const heartbeatHandler = new HeartbeatHandler();
